// V2 分支默认作为可独立部署的演示环境；正式接入后台时显式设置为 false。
export const isDemoMode = process.env.VUE_APP_DEMO_MODE !== "false";
